import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { requestPhaseList, resetPhasePagination } from 'actionCreators';
import { can } from '../../../../../../../../services';
import { getRole, getPosition } from '../../../../../../../../reducers';
import CardTitle from 'components/CardTitle';
import SearchBox from 'components/SearchBox';
import PhaseCard from '../../../../phaseList/components/phaseCard';
import Loading from 'components/Loading';
import PhaseType, { PhaseIndexType } from 'types/phase';

import styles from '../styles.scss';

class PhaseSearch extends Component {
  componentWillMount = () => {
    const { phase: { street_address = '', city = '', state = '', zip_code = '', customer_name = '' } } = this.props;
    const initialQuery = `${street_address}, ${city}, ${state}, ${zip_code}, ${customer_name}`;
    this.search({ query: initialQuery, limit: 3 });
    this.state = { searchTerms: '' };
  }

  onSearch = (e) => {
    e.preventDefault();
    const searchTerms = e.target.query.value.trim() || undefined;
    this.setState({ searchTerms }, () => this.search({ query: searchTerms }));
  }

  search = query => this.props.resetPhasePagination(query)
    .then(() => this.props.requestPhaseList());

  renderPhaseList = (phaseList) => {
    if (this.props.loading) {
      return (<Loading />);
    } else if (phaseList.length === 0) {
      return (<div className={styles.emptyRelatedPhasesContainer}>
        <span className={styles.emptyText}>
          We couldn&apos;t find anything. Try using the search box above.
        </span>
      </div>);
    }
    return (phaseList);
  }

  render = () => {
    const { phases, role, position, relatedPhaseIds, onLinkClick,
            phase: { id: currId = null } } = this.props;
    const phaseList = phases.filter(phase =>
      (phase.id !== currId && relatedPhaseIds.indexOf(phase.id) === -1))
      .map((phase) => {
        const { id = null, surface_type = null, store = null } = phase;
        const actionButton = can(role, 'relate', 'phase') ?
          { text: 'Link Phase', onClick: () => onLinkClick(id) } : null;
        return (<PhaseCard
          key={`phase-${id}`}
          role={role}
          position={position}
          phase={phase}
          onSelect={this.viewAction}
          surfaceType={surface_type}
          store={store}
          actionButton={actionButton}
        />);
      });
    return (<div>
      <CardTitle
        title="Phase Search"
        subtitle="We've tried to find some possible matches."
      >
        <SearchBox
          placeholder="Search by customer name, PO number, address, phone..."
          theme={styles}
          value={this.state.searchTerms}
          onSubmit={this.onSearch}
        />
      </CardTitle>
      <div className={styles.relatedPhasesSectionContainer}>
        {this.renderPhaseList(phaseList)}
      </div>
    </div>);
  }
}

PhaseSearch.propTypes = {
  requestPhaseList: PropTypes.func.isRequired,
  resetPhasePagination: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  phases: PropTypes.arrayOf(PhaseIndexType),
  phase: PhaseType.isRequired,
  onLinkClick: PropTypes.func,
  relatedPhaseIds: PropTypes.arrayOf(PropTypes.number),
};

PhaseSearch.defaultProps = {
  relatedPhaseIds: [],
  role: '',
  position: '',
  loading: false,
  phases: [],
  phase: {},
};

export default connect(state => ({
  phases: state.phases.results,
  searchFilter: state.phases.filters.data,
  loading: state.phases.common.loading,
  role: getRole(state),
  position: getPosition(state),
}), { requestPhaseList, resetPhasePagination })(PhaseSearch);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/relatedPhases/components/phaseSearch.jsx